/**
 * localStorage, maar dan eentje die nooit gooit.
 *
 * Waarom dit er is: in een privévenster van Safari gooit `setItem` een fout, en
 * met cookies helemaal uit gooit zelfs `window.localStorage` aanraken al. Eén zo'n
 * fout halverwege een functie breekt de rest van die functie af. In deze app zat
 * dat bijvoorbeeld in `closeWelcome`, die eerst opslaat en daarna pas het venster
 * sluit: gooit de eerste regel, dan blijf je op de voorpagina vastzitten met een
 * welkomstvenster dat niet meer weggaat.
 *
 * Onthouden lukt dan niet, en dat is jammer maar niet erg. De app moet blijven
 * werken, dat is het punt.
 */

/** Eén keer uitzoeken of er überhaupt een opslag is; daarna niet meer proberen. */
let backing;

function storage() {
  if (backing !== undefined) return backing;
  try {
    const s = window.localStorage;
    // Alleen kijken is niet genoeg: sommige browsers laten je lezen en gooien pas
    // bij het schrijven. Dus even echt proberen.
    const probe = '__paal_probe__';
    s.setItem(probe, '1');
    s.removeItem(probe);
    backing = s;
  } catch (e) {
    backing = null;
  }
  return backing;
}

/** Zelfde antwoord als getItem: de tekst, of null als er niets is. */
export function get(key) {
  const s = storage();
  if (!s) return null;
  try {
    return s.getItem(key);
  } catch (e) {
    return null;
  }
}

/** Levert true als het gelukt is, zodat een aanroeper er iets mee kán. */
export function set(key, value) {
  const s = storage();
  if (!s) return false;
  try {
    s.setItem(key, value);
    return true;
  } catch (e) {
    // Vol geheugen of privémodus. Niet erg genoeg om de gebruiker mee lastig te
    // vallen; het enige gevolg is dat de app dit de volgende keer vergeten is.
    return false;
  }
}

export function remove(key) {
  const s = storage();
  if (!s) return false;
  try {
    s.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
}

/** Alleen voor tests: de gevonden opslag vergeten en opnieuw laten uitzoeken. */
export function resetForTests() {
  backing = undefined;
}
